import type { TransactionProperty } from '@/features/InvoiceReport/Edit/type';

/**
 * Hide columns based on plan and visibility:
 * - corporate plan: hide when not visible AND no custom item key in the row
 * - Team plan: hide only custom columns when no custom item key (basic columns always show)
 */
export function shouldHideTransactionPropertyColumn(
  property: TransactionProperty,
  isMoreThanTeamPlan: boolean,
  hasCustomKey: boolean
): boolean {
  const isCustomProperty = property.type === 'custom';
  return isMoreThanTeamPlan
    ? !property.isVisible && !hasCustomKey
    : isCustomProperty && !hasCustomKey;
}
